<template>
    <div>
        <div v-if="!isLoading && hasDocuments" class="row align-items-center">
            <div class="col-3" v-for="document in documents" @click="$emit('select', document)">
                <div :style="(document.selected ? 'border: 4px solid #2196f3;' : 'border: 4px solid transparent;') + 'margin-bottom: .5rem;'">
                    <img :src="document.preview_url.replace('_dimensions_', 'w300')" style="width: 100%; height: auto;">
                </div>
            </div>
        </div>
        <div v-else-if="!isLoading && !hasDocuments" class="col">
            <h3 class="subtle text-center" style="margin: 2rem; font-weight: normal;">No documents</h3>
        </div>
        <div v-else class="row">
            <div class="col">
                <div style="padding: 3rem;">
                    <ui-progress-circular :size="48" style="margin:auto;" :stroke="2" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            isLoading: {
                type: Boolean,
                default: false,
            },
            documents: {
                type: Array,
                default() {
                    return []
                }
            }
        },
        computed: {
            hasDocuments() {
                return this.documents.length > 0
            }
        }
    }
</script>